<ion-content no-bounce>
  <div class="login-background"></div>
  <ion-grid no-padding>
    <ion-row justify-content-center no-padding style="justify-content: center">
      <ion-col size-sm="8" size-lg="6" size-xl="4" align-self-center no-padding>
        <div class="login-header" class="ion-text-center">
          <img class="logo" src="assets/pe-pro-logo.png" alt="PE Pro Logo" />
        </div>
        <div class="login-container-wrapper">
          @if (isLoading || credentialsService.isLoadingProfile) {
            <div class="login-spinner-wrapper">
              <ion-spinner class="primary-spinner"></ion-spinner>
            </div>
          }
          @if (credentialsService.isAuthenticated && !isLoading && !credentialsService.isLoadingProfile) {
            <app-logged-in></app-logged-in>
          }
          @if (!credentialsService.isAuthenticated && !isLoading && !credentialsService.isLoadingProfile) {
            <div class="login-container">
              @if (!resetPassword) {
                <app-login-form></app-login-form>
              }
              @if (resetPassword) {
                <app-reset-password-email></app-reset-password-email>
              }
            </div>
          }
        </div>
        <p class="ion-padding version-number">Current version: {{ version }}</p>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
